import { render, staticRenderFns } from "./SwitchDetailButton.vue?vue&type=template&id=2ec7fbc3&scoped=true"
import script from "./SwitchDetailButton.vue?vue&type=script&lang=ts"
export * from "./SwitchDetailButton.vue?vue&type=script&lang=ts"
import style0 from "./SwitchDetailButton.vue?vue&type=style&index=0&id=2ec7fbc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec7fbc3",
  null
  
)

export default component.exports